import Joi from 'joi';

export const LOCALIZATION_TEXTS = {
  us: {
    signIn: 'Sign in to Roland Cloud',
    email: 'Email',
    password: 'Password',
    newToRoland: 'New to Roland Cloud?',
    forgotPw: 'Forgot Password?',
    joinNow: 'Join now',
    resetHere: 'Reset it here',
    reset: 'Reset your password',
    back: 'Back to login',
    invalidEmail: 'This field needs to be a valid email',
    emptyEmail: 'This field needs to be a valid email',
    accountNotActivated: 'This account is not activated. Please check your email for the activation code, or click ',
    here: 'here',
    resend: ' to resend.',
    incorrectCredentials: 'Username or password incorrect. Please try again or create an account ',
    invalidRequest: 'The client application made an invalid request.',
    emailSent: 'An email has been sent with instructions for you to reset your password.',
    please: 'Please',
    contactUs: 'Contact us',
    furtherAssistance: 'for further assistance resetting your password.',
    launchingRCM: 'Launching Roland Cloud Manager',
    unknownError: 'An unknown error has ocurred, please try again later',
    success: 'Success',
    youreSignedIn: 'You are now signed in',
    toContinue: 'To continue, close this window and return to Roland Cloud Manager',
    capsLock: 'Caps Lock is on',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'This field needs to be a valid email',
              'string.empty': 'This field needs to be a valid email',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'This field needs to be a valid email',
            'string.empty': 'This field needs to be a valid email',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Please provide a password',
          }),
        },
      },
    },
  },
  mx: {
    signIn: 'Inicia sesión en Roland Cloud',
    email: 'Correo',
    password: 'Contraseña',
    newToRoland: '¿Nuevo en Roland Cloud?',
    forgotPw: '¿Olvidaste tu contraseña?',
    joinNow: 'Únete ahora',
    resetHere: 'Restablécela aquí',
    reset: 'Restablece tu contraseña',
    back: 'Regresa al inicio',
    invalidEmail: 'Ingresa correo electrónico válido',
    emptyEmail: 'Ingresa correo electrónico válido',
    userNotActivated: 'Esta cuenta no está activa. Revisa tu correo por el código de activación, o haz click ',
    here: 'aquí',
    resend: ' para un reenvio.',
    incorrectCredentials: 'Usuario o contraseñas incorrectas. Inténtalo de nuevo o crea una cuenta ',
    invalidRequest: 'La aplicación hizo una solicitud inválida.',
    emailSent: 'Se te ha enviado un correo con instrucciones para restablecer tu contraseña.',
    please: 'Por favor',
    contactUs: 'Contáctanos',
    furtherAssistance: 'para ayudarte a restablecer tu contraseña.',
    launchingRCM: 'Iniciando Roland Cloud Manager',
    unknownError: 'Ha sucedido un error inesperado, intente más tarde por favor',
    success: 'Inicio exitoso',
    youreSignedIn: 'Has iniciado sesión',
    toContinue: 'Para continuar, cierra esta ventana y vuelve a Roland Cloud Manager',
    capsLock: 'Mayúsculas activadas',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Por favor ingresa un correo válido',
              'string.empty': 'Por favor ingresa un correo válido',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Por favor ingresa un correo válido',
            'string.empty': 'Por favor ingresa un correo válido',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Por favor ingresa tu contraseña',
          }),
        },
      },
    },
  },
  no: {
    signIn: 'Logg på Roland Cloud',
    email: 'Email',
    password: 'Passord',
    newToRoland: 'Ny på Roland Cloud?',
    forgotPw: 'Glemt passord?',
    joinNow: 'Bli med nå',
    resetHere: 'Tilbakestill det her',
    reset: 'Tilbakestill passordet ditt',
    back: 'Tilbake til innlogging',
    invalidEmail: 'Dette feltet må være en gyldig e -post',
    emptyEmail: 'Dette feltet må være en gyldig e -post',
    userNotActivated: 'Denne kontoen er ikke aktivert. Vennligst sjekk e -posten din for aktiveringskoden, eller klikk ',
    here: 'her',
    resend: ' å sende på nytt.',
    incorrectCredentials: 'Feil brukernavn eller passord. Prøv igjen, eller opprett en konto ',
    invalidRequest: 'Klientapplikasjonen sendte en ugyldig forespørsel.',
    emailSent: 'Det er sendt en e -post med instruksjoner for å tilbakestille passordet ditt.',
    please: 'Vær så snill',
    contactUs: 'Kontakt oss',
    furtherAssistance: 'for ytterligere hjelp med å tilbakestille passordet ditt..',
    launchingRCM: 'Lanserer Roland Cloud Manager',
    unknownError: 'Det har oppstått en ukjent feil. Prøv igjen senere',
    success: 'Suksess',
    youreSignedIn: 'Du er nå logget inn',
    toContinue: 'For å fortsette, lukk dette vinduet og gå tilbake til Roland Cloud Manager',
    capsLock: 'Caps Lock er på',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Dette feltet må være en gyldig e -post',
              'string.empty': 'Dette feltet må være en gyldig e -post',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Dette feltet må være en gyldig e -post',
            'string.empty': 'Dette feltet må være en gyldig e -post',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Oppgi et passord',
          }),
        },
      },
    },
  },
  se: {
    signIn: 'Logga in på Roland Cloud',
    email: 'Email',
    password: 'Lösenord',
    newToRoland: 'Ny på Roland Cloud?',
    forgotPw: 'Glömt ditt lösenord?',
    joinNow: 'Gå med nu',
    resetHere: 'Återställ det här',
    reset: 'Återställ ditt lösenord',
    back: 'Tillbaka till login',
    invalidEmail: 'Detta fält måste vara ett giltigt e -postmeddelande',
    emptyEmail: 'Detta fält måste vara ett giltigt e -postmeddelande',
    userNotActivated: 'Det här kontot är inte aktiverat. Kontrollera din e -post om aktiveringskoden eller klicka ',
    here: 'här',
    resend: ' att skicka igen.',
    incorrectCredentials: 'Fel användarnamn eller lösenord. Försök igen eller skapa ett konto ',
    invalidRequest: 'Klientprogrammet gjorde en ogiltig begäran.',
    emailSent: 'Ett e -postmeddelande har skickats med instruktioner för dig att återställa ditt lösenord.',
    please: 'Snälla du',
    contactUs: 'Kontakta oss',
    furtherAssistance: 'för ytterligare hjälp med att återställa ditt lösenord.',
    launchingRCM: 'Lanserar Roland Cloud Manager',
    unknownError: 'Ett okänt fel har inträffat. Försök igen senare',
    success: 'Framgång',
    youreSignedIn: 'Du är nu inloggad',
    toContinue: 'För att fortsätta, stäng det här fönstret och återgå till Roland Cloud Manager',
    capsLock: 'Caps Lock är på',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Detta fält måste vara ett giltigt e -postmeddelande',
              'string.empty': 'Detta fält måste vara ett giltigt e -postmeddelande',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Detta fält måste vara ett giltigt e -postmeddelande',
            'string.empty': 'Detta fält måste vara ett giltigt e -postmeddelande',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Ange ett lösenord',
          }),
        },
      },
    },
  },
  dk: {
    signIn: 'Log ind på Roland Cloud',
    email: 'Email',
    password: 'Adgangskode',
    newToRoland: 'Ny på Roland Cloud?',
    forgotPw: 'Glemt kodeord?',
    joinNow: 'Deltag nu',
    resetHere: 'Nulstil det her',
    reset: 'Nulstil din adgangskode',
    back: 'Tilbage til login',
    invalidEmail: 'Dette felt skal være en gyldig e -mail',
    emptyEmail: 'Dette felt skal være en gyldig e -mail',
    userNotActivated: 'Denne konto er ikke aktiveret. Tjek venligst din e -mail for aktiveringskoden, eller klik ',
    here: 'her',
    resend: ' at sende igen.',
    incorrectCredentials: 'Forkert brugernavn eller adgangskode. Prøv igen, eller opret en konto ',
    invalidRequest: 'Klientapplikationen fremsatte en ugyldig anmodning.',
    emailSent: 'Der er sendt en e -mail med instruktioner om, hvordan du nulstiller din adgangskode.',
    please: 'Vær venlig',
    contactUs: 'Kontakt os',
    furtherAssistance: 'for yderligere hjælp til at nulstille din adgangskode.',
    launchingRCM: 'Lancering af Roland Cloud Manager',
    unknownError: 'Der er opstået en ukendt fejl. Prøv igen senere',
    success: 'Succes',
    youreSignedIn: 'Du er nu logget ind',
    toContinue: 'For at fortsætte skal du lukke dette vindue og vende tilbage til Roland Cloud Manager',
    capsLock: 'Caps Lock er på',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Dette felt skal være en gyldig e -mail',
              'string.empty': 'Dette felt skal være en gyldig e -mail',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Dette felt skal være en gyldig e -mail',
            'string.empty': 'Dette felt skal være en gyldig e -mail',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Angiv en adgangskode',
          }),
        },
      },
    },
  },
  fi: {
    signIn: 'Kirjaudu sisään Roland Cloud',
    email: 'Email',
    password: 'Salasana',
    newToRoland: 'Oletko uusi Roland Cloudin käyttäjä?',
    forgotPw: 'Unohtuiko salasana??',
    joinNow: 'Liity nyt',
    resetHere: 'Nollaa se tästä',
    reset: 'Nollaa salasana',
    back: 'Regresa al inicio',
    invalidEmail: 'Takaisin sisäänkirjautumiseen',
    emptyEmail: 'Takaisin sisäänkirjautumiseen',
    userNotActivated: 'Tätä tiliä ei ole aktivoitu. Tarkista aktivointikoodi sähköpostistasi tai napsauta ',
    here: 'tässä',
    resend: ' lähettää uudelleen.',
    incorrectCredentials: 'Väärä käyttäjätunnus tai salasana. Yritä uudelleen tai luo tili ',
    invalidRequest: 'Asiakassovellus teki virheellisen pyynnön.',
    emailSent: 'Sähköpostissa on ohjeet salasanan vaihtamiseen.',
    please: 'Ole kiltti',
    contactUs: 'Ota meihin yhteyttä',
    furtherAssistance: 'saadaksesi lisätietoja salasanan vaihtamisesta.',
    launchingRCM: 'Käynnistämme Roland Cloud Manager',
    unknownError: 'Tapahtui tuntematon virhe. Yritä myöhemmin uudelleen',
    success: 'Menestys',
    youreSignedIn: 'Olet nyt kirjautunut sisään',
    toContinue: 'Jatka sulkemalla tämä ikkuna ja palaamalla Roland Cloud Manageriin',
    capsLock: 'CAPS LOCK on päällä',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Tämän kentän on oltava kelvollinen sähköpostiosoite',
              'string.empty': 'Tämän kentän on oltava kelvollinen sähköpostiosoite',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Tämän kentän on oltava kelvollinen sähköpostiosoite',
            'string.empty': 'Tämän kentän on oltava kelvollinen sähköpostiosoite',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Anna salasana',
          }),
        },
      },
    },
  },
  nl: {
    signIn: 'Aanmelden bij Roland Cloud',
    email: 'Email',
    password: 'Salasana',
    newToRoland: 'Nieuw bij Roland Cloud?',
    forgotPw: 'Wachtwoord vergeten?',
    joinNow: 'Word nu lid',
    resetHere: 'Reset het hier',
    reset: 'Stel je wachtwoord opnieuw in',
    back: 'Terug naar Inloggen',
    invalidEmail: 'Dit veld moet een geldig e-mailadres zijn',
    emptyEmail: 'Dit veld moet een geldig e-mailadres zijn',
    userNotActivated: 'Dit account is niet geactiveerd. Controleer uw e-mail voor de activeringscode, of klik op ',
    here: 'hier',
    resend: ' opnieuw verzenden.',
    incorrectCredentials: 'Verkeerde gebruikersnaam of wachtwoord. Probeer het opnieuw of maak een account aan ',
    invalidRequest: 'De clienttoepassing heeft een ongeldig verzoek gedaana.',
    emailSent: 'Er is een e-mail verzonden met instructies om uw wachtwoord opnieuw in te stellen.',
    please: 'Alstublieft',
    contactUs: 'Neem contact met ons op',
    furtherAssistance: 'voor verdere hulp bij het opnieuw instellen van uw wachtwoord.',
    launchingRCM: 'Roland Cloud Manager starten',
    unknownError: 'Er is een onbekende fout opgetreden, probeer het later opnieuw',
    success: 'Succes',
    youreSignedIn: 'U bent nu aangemeld',
    toContinue: 'Om verder te gaan, sluit dit venster en keer terug naar Roland Cloud Manager',
    capsLock: 'Caps Lock staat aan',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Dit veld moet een geldig e-mailadres zijn',
              'string.empty': 'Dit veld moet een geldig e-mailadres zijn',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Dit veld moet een geldig e-mailadres zijn',
            'string.empty': 'Dit veld moet een geldig e-mailadres zijn',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Geef een wachtwoord op',
          }),
        },
      },
    },
  },
  de: {
    signIn: 'Melden Sie sich bei Roland Cloud an',
    email: 'Email',
    password: 'Passwort',
    newToRoland: 'Neu bei Roland Cloud?',
    forgotPw: 'Passwort vergessen?',
    joinNow: 'Jetzt beitreten',
    resetHere: 'Reset het hier',
    reset: 'Setze dein Passwort zurück',
    back: 'Zurück zur Anmeldung',
    invalidEmail: 'Dieses Feld muss eine gültige E-Mail-Adresse sein',
    emptyEmail: 'Dieses Feld muss eine gültige E-Mail-Adresse sein',
    userNotActivated: 'Dieses Konto ist nicht aktiviert. Bitte überprüfen Sie Ihre E-Mail auf den Aktivierungscode oder klicken Sie auf ',
    here: 'hier',
    resend: ' wiederversenden.',
    incorrectCredentials: 'Falscher Benutzername oder falsches Passwort. Bitte versuchen Sie es erneut oder erstellen Sie ein Konto ',
    invalidRequest: 'Die Clientanwendung hat eine ungültige Anfrage gestellt.',
    emailSent: 'Es wurde eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts gesendet.',
    please: 'Bitte',
    contactUs: 'Kontaktiere uns',
    furtherAssistance: 'für weitere Unterstützung beim Zurücksetzen Ihres Passworts.',
    launchingRCM: 'Starten von Roland Cloud Manager',
    unknownError: 'Ein unbekannter Fehler ist aufgetreten, bitte versuchen Sie es später erneut',
    success: 'Erfolg',
    youreSignedIn: 'Sie sind jetzt angemeldet',
    toContinue: 'Um fortzufahren, schließen Sie dieses Fenster und kehren Sie zu Roland Cloud Manager zurück',
    capsLock: 'Die Feststelltaste ist aktiviert',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Dieses Feld muss eine gültige E-Mail-Adresse sein',
              'string.empty': 'Dieses Feld muss eine gültige E-Mail-Adresse sein',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Dieses Feld muss eine gültige E-Mail-Adresse sein',
            'string.empty': 'Dieses Feld muss eine gültige E-Mail-Adresse sein',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Bitte geben Sie ein Passwort ein',
          }),
        },
      },
    },
  },
  fr: {
    signIn: 'Se connecter à Roland Cloud',
    email: 'Email',
    password: 'Mot de passe',
    newToRoland: 'Nouveau sur Roland Cloud ?',
    forgotPw: 'Mot de passe oublié?',
    joinNow: 'Adhérer maintenant',
    resetHere: 'Réinitialisez-le ici',
    reset: 'Réinitialisez votre mot de passe',
    back: 'Retour connexion',
    invalidEmail: 'Ce champ doit être un email valide',
    emptyEmail: 'Ce champ doit être un email valide',
    userNotActivated: 'Ce compte n\'est pas activé. Veuillez vérifier votre e-mail pour le code d\'activation, ou cliquez sur ',
    here: 'ici',
    resend: ' renvoyer.',
    incorrectCredentials: 'Nom d\'utilisateur ou mot de passe erroné. Veuillez réessayer ou créer un compte ',
    invalidRequest: 'L\'application cliente a fait une demande invalide.',
    emailSent: 'Un e-mail vous a été envoyé avec les instructions pour réinitialiser votre mot de passe.',
    please: 'S\'il vous plaît',
    contactUs: 'Nous contacter',
    furtherAssistance: 'pour obtenir de l\'aide supplémentaire pour réinitialiser votre mot de passe.',
    launchingRCM: 'Lancement de Roland Cloud Manager',
    unknownError: 'Une erreur inconnue s\'est produite, veuillez réessayer plus tard',
    success: 'Succès',
    youreSignedIn: 'Vous êtes maintenant inscrit',
    toContinue: 'Pour continuer, fermez cette fenêtre et revenez à Roland Cloud Manager',
    capsLock: 'Touche Maj activée',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Ce champ doit être un email valide',
              'string.empty': 'Ce champ doit être un email valide',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Ce champ doit être un email valide',
            'string.empty': 'Ce champ doit être un email valide',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Veuillez fournir un mot de passe',
          }),
        },
      },
    },
  },
  it: {
    signIn: 'Accedi a Roland Cloud',
    email: 'Email',
    password: 'Parola d\'ordine',
    newToRoland: 'Nuovo in Roland Cloud?',
    forgotPw: 'Ha dimenticato la password?',
    joinNow: 'Iscriviti adesso',
    resetHere: 'Reimpostalo qui',
    reset: 'Reimposta la tua password',
    back: 'Torna al login',
    invalidEmail: 'Questo campo deve essere un\'e-mail valida',
    emptyEmail: 'Questo campo deve essere un\'e-mail valida',
    userNotActivated: 'Questo account non è attivato. Controlla la tua e-mail per il codice di attivazione o fai clic su ',
    here: 'qui',
    resend: ' rispedire.',
    incorrectCredentials: 'Nome utente o password errati. Riprova o crea un account ',
    invalidRequest: 'L\'applicazione client ha effettuato una richiesta non valida.',
    emailSent: 'È stata inviata un\'e-mail con le istruzioni per reimpostare la password.',
    please: 'Per favore',
    contactUs: 'Contattaci',
    furtherAssistance: ' per ulteriore assistenza nella reimpostazione della password.',
    launchingRCM: 'Avvio di Roland Cloud Manager',
    unknownError: 'Si è verificato un errore sconosciuto, riprova più tardi',
    success: 'Successo',
    youreSignedIn: 'Hai effettuato l\'accesso',
    toContinue: 'Per continuare, chiudi questa finestra e torna a Roland Cloud Manager',
    capsLock: 'Blocco maiuscolo attivo',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Questo campo deve essere un\'e-mail valida',
              'string.empty': 'Questo campo deve essere un\'e-mail valida',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Questo campo deve essere un\'e-mail valida',
            'string.empty': 'Questo campo deve essere un\'e-mail valida',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Si prega di fornire una password',
          }),
        },
      },
    },
  },
  br: {
    signIn: 'Faça login no Roland Cloud',
    email: 'Email',
    password: 'Senha',
    newToRoland: 'Novo no Roland Cloud?',
    forgotPw: 'Esqueceu sua senha?',
    joinNow: 'Entrar',
    resetHere: 'Reinicialize aqui',
    reset: 'Redefina sua senha',
    back: 'Volte ao login',
    invalidEmail: 'Este campo precisa ser um e-mail válido',
    emptyEmail: 'Este campo precisa ser um e-mail válido',
    userNotActivated: 'Esta conta não está ativada. Verifique seu e-mail para obter o código de ativação ou clique em ',
    here: 'aqui',
    resend: ' para reenviar.',
    incorrectCredentials: 'Nome de usuário ou senha incorretos. Por favor, tente novamente ou crie uma conta ',
    invalidRequest: 'O aplicativo cliente fez uma solicitação inválida.',
    emailSent: 'Um e-mail foi enviado com instruções para você redefinir sua senha.',
    please: 'Por favor',
    contactUs: 'Contate-Nos',
    furtherAssistance: 'para obter mais assistência para redefinir sua senha.',
    launchingRCM: 'Lançamento do Roland Cloud Manager',
    unknownError: 'Ocorreu um erro desconhecido, tente novamente mais tarde',
    success: 'Sucesso',
    youreSignedIn: 'Agora você está conectado',
    toContinue: 'Para continuar, feche esta janela e volte ao Roland Cloud Manager',
    capsLock: 'Caps Lock está ativado',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Este campo precisa ser um e-mail válido',
              'string.empty': 'Este campo precisa ser um e-mail válido',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Este campo precisa ser um e-mail válido',
            'string.empty': 'Este campo precisa ser um e-mail válido',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Forneça uma senha',
          }),
        },
      },
    },
  },
  ru: {
    signIn: 'Войдите в Roland Cloud',
    email: 'Email',
    password: 'Пароль',
    newToRoland: 'Впервые в Roland Cloud?',
    forgotPw: 'Забыли пароль?',
    joinNow: 'Присоединяйся сейчас',
    resetHere: 'Сбросить здесь',
    reset: 'Сбросить пароль',
    back: 'Вернуться на страницу входа',
    invalidEmail: 'В этом поле должен быть действующий адрес электронной почты.',
    emptyEmail: 'В этом поле должен быть действующий адрес электронной почты.',
    userNotActivated: 'Эта учетная запись не активирована. Пожалуйста, проверьте свою электронную почту, чтобы получить код активации, или нажмите ',
    here: 'здесь',
    resend: ' повторно отправить.',
    incorrectCredentials: 'Неверное имя пользователя или пароль. Пожалуйста, попробуйте еще раз или создайте аккаунт ',
    invalidRequest: 'Клиентское приложение сделало неверный запрос.',
    emailSent: 'Было отправлено письмо с инструкциями по сбросу пароля.',
    please: 'Пожалуйста',
    contactUs: 'Свяжитесь с нами',
    furtherAssistance: 'для получения дополнительной помощи по сбросу пароля.',
    launchingRCM: 'Запуск Roland Cloud Manager',
    unknownError: 'Произошла неизвестная ошибка. Повторите попытку позже.',
    success: 'успех',
    youreSignedIn: 'Вы вошли в систему',
    toContinue: 'Чтобы продолжить, закройте это окно и вернитесь в Roland Cloud Manager.',
    capsLock: 'Включен верхний регистр',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'В этом поле должен быть действующий адрес электронной почты',
              'string.empty': 'В этом поле должен быть действующий адрес электронной почты',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'В этом поле должен быть действующий адрес электронной почты',
            'string.empty': 'В этом поле должен быть действующий адрес электронной почты',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Пожалуйста, укажите пароль',
          }),
        },
      },
    },
  },
  ro: {
    signIn: 'Conectați-vă la Roland Cloud',
    email: 'Email',
    password: 'Parola',
    newToRoland: 'Nou în Roland Cloud?',
    forgotPw: 'Ați uitat parola?',
    joinNow: 'Alătură-te acum',
    resetHere: 'Resetați-l aici',
    reset: 'Reseteaza parola',
    back: 'Înapoi la autentificare',
    invalidEmail: 'Acest câmp trebuie să fie un e-mail valid',
    emptyEmail: 'Acest câmp trebuie să fie un e-mail valid',
    userNotActivated: 'EAcest cont nu este activat. Vă rugăm să verificați adresa de e-mail pentru codul de activare sau faceți clic pe ',
    here: 'aici',
    resend: ' a retrimite.',
    incorrectCredentials: 'Nume de utilizator sau parolă greșită. Încercați din nou sau creați un cont ',
    invalidRequest: 'Aplicația client a făcut o solicitare nevalidă.',
    emailSent: 'A fost trimis un e-mail cu instrucțiuni pentru a vă reseta parola.',
    please: 'Vă rog',
    contactUs: 'Contactează-ne',
    furtherAssistance: 'pentru asistență suplimentară la resetarea parolei.',
    launchingRCM: 'Lansarea Roland Cloud Manager',
    unknownError: 'A apărut o eroare necunoscută, încercați din nou mai târziu',
    success: 'Succes',
    youreSignedIn: 'Acum sunteți conectat',
    toContinue: 'Pentru a continua, închideți această fereastră și reveniți la Roland Cloud Manager',
    capsLock: 'Caps Lock este activ',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Acest câmp trebuie să fie un e-mail valid',
              'string.empty': 'Acest câmp trebuie să fie un e-mail valid',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Acest câmp trebuie să fie un e-mail valid',
            'string.empty': 'Acest câmp trebuie să fie un e-mail valid',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Vă rugăm să furnizați o parolă',
          }),
        },
      },
    },
  },
  sk: {
    signIn: 'Prihláste sa do Roland Cloud',
    email: 'Email',
    password: 'Heslo',
    newToRoland: 'Začínate s Roland Cloud?',
    forgotPw: 'Zabudol si heslo?',
    joinNow: 'Pridať sa teraz',
    resetHere: 'Resetujte to tu',
    reset: 'Obnoviť heslo',
    back: 'Späť na prihlásenie',
    invalidEmail: 'Toto pole musí byť platný e -mail',
    emptyEmail: 'Toto pole musí byť platný e -mail',
    userNotActivated: 'Tento účet nie je aktivovaný. Skontrolujte svoj e -mail, či neobsahuje aktivačný kód, alebo kliknite na tlačidlo ',
    here: 'tu',
    resend: ' znova poslať.',
    incorrectCredentials: 'Usuario o contraseñas incorrectas. Inténtalo de nuevo o crea una cuenta ',
    invalidRequest: 'Klientska aplikácia odoslala neplatnú požiadavku.',
    emailSent: 'Bol odoslaný e -mail s pokynmi na obnovenie hesla.',
    please: 'Prosím',
    contactUs: 'Kontaktuj nás',
    furtherAssistance: 'ďalšiu pomoc pri obnove hesla.',
    launchingRCM: 'Spustenie Roland Cloud Manager',
    unknownError: 'Vyskytla sa neznáma chyba. Skúste to znova neskôr',
    success: 'Úspech',
    youreSignedIn: 'Teraz ste prihlásení',
    toContinue: 'Ak chcete pokračovať, zatvorte toto okno a vráťte sa do Roland Cloud Manager',
    capsLock: 'Caps lock je zapnutý',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Toto pole musí byť platný e -mail',
              'string.empty': 'Toto pole musí byť platný e -mail',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Toto pole musí byť platný e -mail',
            'string.empty': 'Toto pole musí byť platný e -mail',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Zadajte heslo',
          }),
        },
      },
    },
  },
  cz: {
    signIn: 'Přihlaste se do Roland Cloud',
    email: 'Email',
    password: 'Heslo',
    newToRoland: 'Jste nováčkem v Roland Cloud?',
    forgotPw: 'Zapomenuté heslo?',
    joinNow: 'Přidej se teď',
    resetHere: 'Resetujte to zde',
    reset: 'Obnovit heslo',
    back: 'Späť na prihlásenie',
    invalidEmail: 'Toto pole musí být platný e -mail',
    emptyEmail: 'Toto pole musí být platný e -mail',
    userNotActivated: 'Tento účet není aktivován. Zkontrolujte prosím svůj e -mail, zda obsahuje aktivační kód, nebo klikněte ',
    here: 'tady',
    resend: ' Bez internetového připojení.',
    incorrectCredentials: 'Chybné uživatelské jméno nebo heslo. Zkuste to znovu nebo si vytvořte účet ',
    invalidRequest: 'Klientská aplikace podala neplatný požadavek.',
    emailSent: 'Byl odeslán e -mail s pokyny k obnovení hesla.',
    please: 'Prosím',
    contactUs: 'Kontaktujte nás',
    furtherAssistance: 'další pomoc při obnovení hesla.',
    launchingRCM: 'Spuštění Roland Cloud Manager',
    unknownError: 'Došlo k neznámé chybě. Zkuste to prosím znovu později',
    success: 'Úspěch',
    youreSignedIn: 'Nyní jste přihlášeni',
    toContinue: 'Chcete -li pokračovat, zavřete toto okno a vraťte se do Roland Cloud Manager',
    capsLock: 'Caps Lock je zapnutý',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Toto pole musí být platný e -mail',
              'string.empty': 'Toto pole musí být platný e -mail',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Toto pole musí být platný e -mail',
            'string.empty': 'Toto pole musí být platný e -mail',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Zadejte prosím heslo',
          }),
        },
      },
    },
  },
  hu: {
    signIn: 'Jelentkezzen be a Roland Cloud szolgáltatásba',
    email: 'Email',
    password: 'Jelszó',
    newToRoland: 'Új vagy a Roland Cloudban?',
    forgotPw: 'Elfelejtette jelszavát?',
    joinNow: 'Csatlakozz most',
    resetHere: 'Állítsa vissza itt',
    reset: 'Állítsd vissza a jelszavad',
    back: 'Vissza a bejelentkezéshez',
    invalidEmail: 'Ennek a mezőnek érvényes e -mail címnek kell lennie',
    emptyEmail: 'Ennek a mezőnek érvényes e -mail címnek kell lennie',
    userNotActivated: 'Ez a fiók nincs aktiválva. Kérjük, ellenőrizze az e -mailben az aktiválási kódot, vagy kattintson ',
    here: 'itt',
    resend: ' zaslat znovu.',
    incorrectCredentials: 'Rossz felhasználónév vagy jelszó. Kérjük, próbálja újra, vagy hozzon létre fiókot ',
    invalidRequest: 'Az ügyfélalkalmazás érvénytelen kérelmet nyújtott be.',
    emailSent: 'E -mailt küldtünk a jelszó visszaállítására vonatkozó utasításokkal.',
    please: 'Kérem',
    contactUs: 'Lépjen kapcsolatba velünk',
    furtherAssistance: 'további segítségért a jelszó visszaállításához.',
    launchingRCM: 'A Roland Cloud Manager elindítása',
    unknownError: 'Ismeretlen hiba történt. Kérjük, próbálja újra később',
    success: 'Siker',
    youreSignedIn: 'Most bejelentkezett',
    toContinue: 'A folytatáshoz zárja be ezt az ablakot, és térjen vissza a Roland Cloud Manager -hez',
    capsLock: 'A Caps lock be van kapcsolva',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'Ennek a mezőnek érvényes e -mail címnek kell lennie',
              'string.empty': 'Ennek a mezőnek érvényes e -mail címnek kell lennie',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'Ennek a mezőnek érvényes e -mail címnek kell lennie',
            'string.empty': 'Ennek a mezőnek érvényes e -mail címnek kell lennie',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Kérjük, adjon meg jelszót',
          }),
        },
      },
    },
  },
  pl: {
    signIn: 'Zaloguj się do Roland Cloud',
    email: 'Email',
    password: 'Hasło',
    newToRoland: 'Nowy w Roland Cloud?',
    forgotPw: 'Zapomniałeś hasła?',
    joinNow: 'Dołącz teraz',
    resetHere: 'Zresetuj to tutaj',
    reset: 'Zresetuj swoje hasło',
    back: 'Powrót do logowania',
    invalidEmail: 'To pole musi być prawidłowym adresem e-mail',
    emptyEmail: 'To pole musi być prawidłowym adresem e-mail',
    userNotActivated: 'To konto nie jest aktywowane. Sprawdź pocztę e-mail w celu uzyskania kodu aktywacyjnego lub kliknij ',
    here: 'tutaj',
    resend: ' wysłać ponownie.',
    incorrectCredentials: 'Zła nazwa użytkownika lub hasło. Spróbuj ponownie lub utwórz konto ',
    invalidRequest: 'Aplikacja klienta wysłała nieprawidłowe żądanie.',
    emailSent: 'Wysłano wiadomość e-mail z instrukcjami dotyczącymi resetowania hasła.',
    please: 'Proszę',
    contactUs: 'Skontaktuj się z nami',
    furtherAssistance: 'aby uzyskać dalszą pomoc w resetowaniu hasła.',
    launchingRCM: 'Uruchamianie Roland Cloud Manager',
    unknownError: 'Wystąpił nieznany błąd, spróbuj ponownie później',
    success: 'Powodzenie',
    youreSignedIn: 'Jesteś teraz zalogowany',
    toContinue: 'Aby kontynuować, zamknij to okno i wróć do Roland Cloud Manager',
    capsLock: 'Caps Lock jest włączony',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': 'To pole musi być prawidłowym adresem e-mail',
              'string.empty': 'To pole musi być prawidłowym adresem e-mail',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': 'To pole musi być prawidłowym adresem e-mail',
            'string.empty': 'To pole musi być prawidłowym adresem e-mail',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': 'Podaj hasło',
          }),
        },
      },
    },
  },
  jp: {
    signIn: 'Roland Cloudにサインイン',
    email: 'メールアドレス',
    password: 'パスワード',
    newToRoland: 'Roland Cloudへのご登録はまだですか？',
    forgotPw: 'パスワードをお忘れでしょうか？',
    joinNow: '登録する',
    resetHere: 'パスワード再設定はこちら',
    reset: 'パスワードを再設定する',
    back: 'ログインに戻る',
    invalidEmail: '有効なメールアドレスの入力が必要です',
    emptyEmail: '有効なメールアドレスの入力が必要です',
    userNotActivated: 'アカウントがアクティベートされていません。アクティベーションコードはご登録されたメールをご確認いただくか',
    here: 'こちら',
    resend: '再送する.',
    incorrectCredentials: 'ユーザー名、パスワードが違います。再度お試しいただくか新規にアカウントを作成してください',
    invalidRequest: 'クライアントアプリケーション側で無効なリクエストが行われました',
    emailSent: 'パスワード再設定手順をご登録のメールアドレスへ送付しました',
    please: 'お願いします',
    contactUs: 'お問い合わせはこちら',
    furtherAssistance: 'さらなる支援のために',
    launchingRCM: 'Roland Cloud Managerを起動しています',
    unknownError: 'エラーが発生しました。時間をおいて再度お試しください',
    success: '成功',
    youreSignedIn: 'サインインしました',
    toContinue: '続行するには、このウィンドウを閉じてRoland CloudManagerに戻ります',
    capsLock: 'CapsLockがオンになっています',
    validation: {
      schemas: {
        forgotSchema: {
          email: Joi.string()
            .email({ tlds: { allow: false } })
            .max(50)
            .required()
            .label('Email')
            .messages({
              'string.email': '有効なメールアドレスの入力が必要です',
              'string.empty': '有効なメールアドレスの入力が必要です',
            }),
        },
        loginSchema: {
          email: Joi.string().email({ tlds: { allow: false } }).max(50).required().label('Email').messages({
            'string.email': '有効なメールアドレスの入力が必要です',
            'string.empty': '有効なメールアドレスの入力が必要です',
          }),
          password: Joi.string().required().label('Password').max(100).messages({
            'string.empty': '有効なメールアドレスの入力が必要です',
          }),
        },
      },
    },
  },
};
